import axios from 'axios'
import urlGenerator from './url-generator'
import { property } from 'lodash'
import createRequestConfig from './create-request-config'
import CachedDataService from '../../utilities/cached-data-service'
import sortByName from './sort-by-name'

const cachedDataService = new CachedDataService({ stdTTL: 86400 })

const fetchData = (bypassCache) => {
    const url = urlGenerator.durations()
    return cachedDataService.retrieveData(url, async () => axios.get(url, createRequestConfig()).then(property('data')).then(sortByName), bypassCache)
}

export default fetchData